import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
    MDBBtn,
    MDBContainer,
    MDBCard,
    MDBCardBody,
    MDBCol,
    MDBRow,
    MDBInput,
    MDBCheckbox
} from 'mdb-react-ui-kit';

import { Routes } from "../../routes";
import { loginUser } from "../../services/authService";

export default () => {
    const [formData, setFormData] = useState({ identifier: "", password: "" });
    const [error, setError] = useState("");
    const history = useHistory();
    const [rememberMe, setRememberMe] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        try {
            const data = await loginUser(formData.identifier, formData.password);

            if (rememberMe) {
                localStorage.setItem("accessToken", data.jwt);
            } else {
                sessionStorage.setItem("accessToken", data.jwt);
            }

            history.push(Routes.DashboardOverview.path);
        } catch (error) {
            setError("Login failed: " + error.message);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleSubmit(e);
        }
    };

    return (
        <MDBContainer fluid className="p-0">

            <div className="p-5 bg-image" style={{
                backgroundImage: 'url(https://mdbootstrap.com/img/new/textures/full/171.jpg)',
                height: '300px',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                width: '100%'
            }}></div>

            <MDBCard className='mx-auto mb-5 p-5 shadow-5' style={{
                marginTop: '-180px',
                background: 'hsla(0, 0%, 100%, 0.8)',
                backdropFilter: 'blur(30px)',
                maxWidth: '600px',
                borderRadius: '15px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)'
            }}>
                <MDBCardBody className='p-5 text-center'>

                    <h2 className="fw-bold mb-3" style={{ fontSize: '1.6rem', marginTop: '-20px', whiteSpace: 'nowrap' }}>Ведомственный Портал</h2>
                    <h2 className="fw-bold mb-4" style={{ fontSize: '1.6rem', marginTop: '-10px', whiteSpace: 'nowrap' }}>по деятельности ГАУГИ при КМ КР</h2>

                    <h5 className="fw-bold mb-4" style={{ marginTop: '60px' }}>Войдите</h5>

                    <MDBRow>
                        <MDBCol col='12'>
                            <MDBInput wrapperClass='mb-4' label='Имя пользователя' id='identifier' type='text' value={formData.identifier} name="identifier" onChange={handleChange} onKeyDown={handleKeyDown} />
                        </MDBCol>
                    </MDBRow>

                    <MDBRow>
                        <MDBCol col='12'>
                            <MDBInput wrapperClass='mb-4' label='Пароль' id='password' type='password' value={formData.password} name="password" onChange={handleChange} onKeyDown={handleKeyDown} />
                        </MDBCol>
                    </MDBRow>

                    <div className='d-flex justify-content-center mb-4'>
                        <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='Запомнить меня' checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />
                    </div>

                    {error && <div className="text-danger mb-3">{error}</div>}

                    <MDBBtn className='w-100 mb-4' size='md' onClick={handleSubmit} style={{ transition: 'none', height: '50px', marginTop: '20px' }}>
                        Войти
                    </MDBBtn>
                </MDBCardBody>
            </MDBCard>

        </MDBContainer>
    );
};
